const getPregnancySportWarningId = ({isPregnancy, isEsports, isWsports}) => {
  if (isPregnancy !== 'yes') return null;
  if (isEsports && isWsports) return 'pregnancy_and_extreme_sports_both_covers.title';
  if (isEsports) return 'pregnancy_and_extreme_sports_esports_cover.title';
  if (isWsports) return 'pregnancy_and_extreme_sports_wsports_cover.title';
  return null;
};

export const deriveOfferDisplay = (offer, coverageState, formatMessage) => {
  const warningId = getPregnancySportWarningId(coverageState);
  const additionalPrices = (offer.additionalPrices || []).filter(({title}) => {
    if (title === 'הריון' && coverageState.isPregnancy !== 'yes') return false;
    if (title === 'מצב רפואי קיים' && !offer.coverExistingMedical) return false;
    return true;
  });
  const insuranceCovers = [...(offer.insuranceCovers || [])];

  if (warningId) {
    insuranceCovers.push({
      warning: true,
      extra: true,
      text: formatMessage({id: warningId}),
      title: ' ',
    });
  }

  return {...offer, additionalPrices, insuranceCovers};
};